export default [
  {
    question: `How do I earn rewards with CANTO?`,
    answer: `Simply connect your wallet and stake your CANTO. The transaction fees accumulated are paid out on a per block basis. You can choose to withdraw your rewards back to your wallet or compound the rewards.`,
  },
  {
    question: `Where does the rewards come from?`,
    answer: `CANTO has a inflationary rewards policy used to incentivise holders to stake. Emissions from inflation are structured in 30 day periods and distributed daily. Inflation is set at 19.84% during the first 30 day period, and subsequently voted by governance to adjust emissions as appropriate (constantly decreasing rate). Over time, emissions of CANTO should trend to zero.`,
  },
  {
    question: `Is there a lockup period?`,
    answer: `There is a 21 days unbonding period when you want to unstake your CANTO from the network. During this period. you earn 0 rewards and will still be suspecitble to slashing.`,
  },
  {
    question: `Are there any risks involved with staking CANTO on unagii?`,
    answer: `Your CANTO will be staked to StakeWith.Us, a Singapore government backed staking infrastructure provider. There are currently no slashing risks involved for downtime and double signing, but rewards will not be assigned to stakers if the validator is down. Read about StakeWith.Us.`,
  },
  {
    question: `Where can I view governance proposals for CANTO? How does voting work?`,
    answer: `You can view governance proposals <a target="_self" href="/stake/canto/proposals">here</a>. In the event you do not vote, your vote will follow the choices of your validator, which in this case, is StakeWith.Us.`,
  },
  {
    question: `Is there a fee?`,
    answer: `There is a delegation commission fee paid to Stakewithus for staking.`,
  },
]